import React from "react";
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import firstImg from '@/assets/frames/first.png';
import secondImg from '@/assets/frames/second.png';
import thirdImg from '@/assets/frames/third.png';
import { useForm, Controller } from 'react-hook-form';

const BpIcon = styled('img')(({ theme }) => ({
    width: '20vw'
}));

const BpCheckedIcon = styled(BpIcon)({
    outline: '2px solid white',
    borderRadius: '8px'
});

const images = {
    neo: firstImg,
    magic: secondImg,
    cat: thirdImg,
}

const BpRadio = (props) => {
    return (
        <Radio
            disableRipple
            checkedIcon={<BpCheckedIcon src={images[props.value]} />}
            icon={<BpIcon src={images[props.value]} />}
            {...props}
        />
    );
}

export default function RadioGroup({ control }) {
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">Select widget type</FormLabel>
            <Controller
                rules={{ required: true }}
                control={control}
                name="widget"
                render={({ field }) => {
                    return (
                        <MuiRadioGroup {...field} row>
                            <BpRadio
                                value="neo"
                            />
                            <BpRadio
                                value="magic"
                            />
                            <BpRadio
                                value="cat"
                            />
                        </MuiRadioGroup>
                    );
                }}
            />
        </FormControl>
    );
}
